"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HelpSectionCC;
exports.scrollToElement = exports.findSelectedCategories = exports.findAllCategories = void 0;
var _react = _interopRequireWildcard(require("react"));
var _navigation = require("next/navigation");
var _HelpSectionStage = _interopRequireDefault(require("./HelpSectionStage/HelpSectionStage"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _findAllCategories = exports.findAllCategories = function findAllCategories(selectedCategory, categories) {
  var currentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  for (var category in categories) {
    var thisCategory = categories[category];
    if (currentPath) {
      currentPath[thisCategory.id] = thisCategory;
    }
    if (thisCategory.id === selectedCategory || thisCategory.categoryLinkId === selectedCategory) {
      return currentPath;
    }
    if (thisCategory.categories && Object.keys(thisCategory.categories).length > 0) {
      var result = _findAllCategories(selectedCategory, thisCategory.categories, currentPath);
      if (result) return result;
    }
  }
  return null;
};
var findSelectedCategories = exports.findSelectedCategories = function findSelectedCategories(selectedCategory, categories) {
  if (!categories) return null;
  var selectedKeys = [];

  // Helper function to find category key by ID or categoryLinkId
  var findCategoryKey = function findCategoryKey(searchValue) {
    // First try to find by direct key match
    if (categories[searchValue]) {
      return searchValue;
    }

    // Then try to find by categoryLinkId
    var foundEntry = Object.entries(categories).find(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        category = _ref2[1];
      return category.categoryLinkId === searchValue;
    });
    return foundEntry ? foundEntry[0] : null;
  };
  var currentCategoryKey = findCategoryKey(selectedCategory);
  while (currentCategoryKey) {
    var _categories$currentCa;
    selectedKeys.unshift(currentCategoryKey);
    var parentId = (_categories$currentCa = categories[currentCategoryKey]) === null || _categories$currentCa === void 0 ? void 0 : _categories$currentCa.parentId;
    if (!parentId) break;
    currentCategoryKey = findCategoryKey(parentId);
  }
  var selectedCategories = Object.fromEntries(Object.entries(categories).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    return selectedKeys.includes(key);
  }));
  return selectedCategories;
};
var scrollToElement = exports.scrollToElement = function scrollToElement(scrollToIdQuery) {
  if (scrollToIdQuery) {
    var element = document.getElementById(scrollToIdQuery);
    element === null || element === void 0 || element.scrollIntoView({
      behavior: 'smooth'
    });
  } else {
    var _element = document.getElementById('scrollTarget');
    if (_element) {
      var SCROLL_OFFSET = -32;
      var top = _element.getBoundingClientRect().top + window.scrollY + SCROLL_OFFSET;
      window.scrollTo({
        top: top
      });
    }
  }
};
function HelpSectionCC(_ref5) {
  var topic = _ref5.topic,
    getResponse = _ref5.getResponse;
  var _useState = (0, _react.useState)(topic),
    _useState2 = _slicedToArray(_useState, 2),
    stepperData = _useState2[0],
    setStepperData = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    response = _useState4[0],
    setResponse = _useState4[1];
  var responseScrollRef = (0, _react.useRef)(null);
  var searchParams = (0, _navigation.useSearchParams)();
  var getNextLevel = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref6) {
      var selectedCategory, stepNumber, updatedSteps, answer;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            selectedCategory = _ref6.selectedCategory, stepNumber = _ref6.stepNumber;
            // clear the response
            setResponse(null);

            // trim the object to required number of steps
            updatedSteps = Object.keys(stepperData).filter(function (step, i) {
              return i <= stepNumber;
            }).reduce(function (acc, step) {
              acc[step] = stepperData[step];
              return acc;
            }, {}); // clear out selected states
            if (selectedCategory.categories) {
              Object.values(selectedCategory.categories).forEach(function (category) {
                category.selected = false;
              });
            }

            // add the new one to the render object
            updatedSteps[selectedCategory.id] = selectedCategory;

            // set the right category as selected in the parent
            if (selectedCategory.parentId) {
              Object.values(updatedSteps[selectedCategory.parentId].categories).forEach(function (category) {
                category.selected = category.id === selectedCategory.id;
              });
            }
            setStepperData(updatedSteps);

            // fetch/set the rendered result if present
            if (!selectedCategory.result) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return getResponse(selectedCategory.result);
          case 1:
            answer = _context.v;
            setResponse(answer);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function getNextLevel(_x) {
      return _ref7.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    var loadCategory = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var onLoadCategory, getOnLoadData, allCategories, categoriesSelected, category, thisCategory, timeout, _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!searchParams) {
                _context3.n = 5;
                break;
              }
              onLoadCategory = searchParams.get('category');
              if (onLoadCategory) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              getOnLoadData = /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(resultId) {
                  var answer;
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        _context2.n = 1;
                        return getResponse(resultId);
                      case 1:
                        answer = _context2.v;
                        setResponse(answer);
                      case 2:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                return function getOnLoadData(_x2) {
                  return _ref9.apply(this, arguments);
                };
              }();
              if (!onLoadCategory) {
                _context3.n = 5;
                break;
              }
              allCategories = _findAllCategories(onLoadCategory, topic);
              categoriesSelected = allCategories ? findSelectedCategories(onLoadCategory, allCategories) : null;
              _t = _regeneratorKeys(categoriesSelected);
            case 2:
              if ((_t2 = _t()).done) {
                _context3.n = 4;
                break;
              }
              category = _t2.value;
              thisCategory = categoriesSelected[category];
              thisCategory.selected = true;
              if (!thisCategory.result) {
                _context3.n = 3;
                break;
              }
              _context3.n = 3;
              return getOnLoadData(thisCategory.result);
            case 3:
              _context3.n = 2;
              break;
            case 4:
              if (!categoriesSelected) {
                _context3.n = 5;
                break;
              }
              setStepperData(categoriesSelected);
              timeout = setTimeout(function () {
                return scrollToElement(searchParams.get('scrollTo'));
              }, 500);
              return _context3.a(2, function () {
                return clearTimeout(timeout);
              });
            case 5:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function loadCategory() {
        return _ref8.apply(this, arguments);
      };
    }();
    loadCategory();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: Object.keys(stepperData).map(function (step, stepNumber) {
      return /*#__PURE__*/(0, _react.createElement)(_HelpSectionStage["default"], _objectSpread(_objectSpread({
        ref: stepNumber === Object.keys(stepperData).length - 1 ? responseScrollRef : null,
        stepNumber: stepNumber
      }, stepperData[step]), {}, {
        key: "step_".concat(stepNumber),
        callback: getNextLevel,
        currentStep: Object.keys(stepperData).length,
        response: stepperData[step].result ? response !== null && response !== void 0 ? response : null : null,
        isResponse: !!stepperData[step].result
      }));
    })
  });
}